"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NON_CATEGORIZED_ITEMS = exports.MILLISECONDS_DAY = exports.OTHER_COURSE = exports.DEFAULT_ENTITY_ID = void 0;
exports.DEFAULT_ENTITY_ID = 'new'; // for ui address bar
exports.OTHER_COURSE = 'OTHER'; // for ui address bar
exports.MILLISECONDS_DAY = 86400000;
exports.NON_CATEGORIZED_ITEMS = 'NON_CATEGORIZED_ITEMS'; // for ui address bar
//# sourceMappingURL=appEvents.js.map